import type { DeepString } from "@/lib/i18n";

/**
 * CFaq - polskie tłumaczenia (akordeon FAQ).
 *
 * `formatQuestion` zastępuje legacy `lang/c_faq_pl.lang::format_question`
 * (`"%s. %s"` z sprintf). Numerowanie zaczynamy od 1.
 */
export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  emptyList: "Aktualnie nie posiadamy żadnych danych w tym dziale.",
  formatQuestion: (index: number, question: string) => `${index}. ${question}`,
  searchLabel: "Wyszukaj w pytaniach",
  searchPlaceholder: "Wpisz frazę, aby przeszukać pytania…",
  formatEmptyResults: (query: string) =>
    `Brak pytań pasujących do „${query}".`,
} as const;

export type CFaqTranslations = DeepString<typeof pl>;
